export default __webpack_public_path__ + "static/7-d1c44bbacac51f71e2d4bb234c46ee2d.jpg";